// Module
var code = "<div class=\"text-center pt-0 py-4 mb-4\"> <a class=\"btn btn-outline-primary fw-600\" href=\"{{link}}\" target=\"{{target}}\">{{label}} <ion-icon class=\"chevron-forward-outline\" name=\"chevron-forward-outline\"></ion-icon></a> </div>";
// Exports
export default code;